var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartupsinline = function SvgStartupsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#startups_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.972 14.595C3.121 15.446.5 15.5.5 15.5s.197-2.479 1.047-3.33c.85-.85 1.737-.085 2.122.303.385.389 1.153 1.27.303 2.122M5.643 7.01l3.347 3.348M14.59 1.41 15.5.5M14.892 4.744l-.303-3.333-3.333-.304A2.56 2.56 0 0 0 8.832 2.32L3.68 9.896l1.212 1.212 1.212 1.213 7.576-5.153a2.56 2.56 0 0 0 1.212-2.424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.643 7.01-.924-.354a1.71 1.71 0 0 0-1.825.39L1.218 8.722a.429.429 0 0 0 .218.723l2.245.45M8.991 10.357l.353.924a1.72 1.72 0 0 1-.389 1.825l-1.677 1.678a.428.428 0 0 1-.723-.219l-.45-2.245M11.256 6.029a1.286 1.286 0 1 0 0-2.572 1.286 1.286 0 0 0 0 2.572"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "startups_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgStartupsinline;